import { GeolocationError } from "@/services/geolocationService";

/**
 * Checks if the given error is a GeolocationError by checking if
 * the error message matches one of the GeolocationError enum values.
 */
export function isGeolocationError(error: Error): boolean {
  return error.message in GeolocationError;
}
